export default __webpack_public_path__ + "static/media/img-0550-denmark-full-face.bf1c50b4.png";